module.exports = __webpack_public_path__ + "static/media/IMG-20181008-WA0106.b74adc3d.jpg";